<app-basic-select [options]="['MR', 'Mrs', 'Ms']" [(ngModel)]="localValue" [iconClass]="'person-vcard fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
